import React, {useState, useEffect} from 'react';
import axios from 'axios';


const ContactMap = () => {

    const [iframemap, setIframemap] = useState([]);

    useEffect(()=>{
        axios.get("https://www.cadandrender.com/adminPanel/API/contact.php").then((response)=>{
            setIframemap(response.data.Contact);
      })
    },[]);

    return(
        <>
        {iframemap.map((res)=>
        <>
            <div className='cadContactMap'>
                <iframe 
                title='cad-map'
                src={res.CadContact_LocationIframeUrl}  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </>
        )}
        </>
    );
}


export default ContactMap;